import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { Button, Col, Container, Image, Row, Card, Table } from 'react-bootstrap';
import { Download, Info } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import NotyfContext from '../../contexts/NotyfContext';
import { fetchCreditReport } from '../../redux/slices/CreditReportSlice';
import { fetchTourProgresses, updateTourProgress } from '../../redux/slices/TourProgressSlice';
// Burea Logos
import TransUnionLogoSm from '../../assets/img/transunion-sm.png';
import ExperianLogoSm from '../../assets/img/experian-sm.png';
import EquifaxLogoSm from '../../assets/img/equifax-sm.png';
import Joyride from 'react-joyride';


const CreditReport = () => {
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: <>Anytime you want to access your past credit reports, you can find them here.</>,
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>Here is the date of the credit report</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: <>Which you can find here as well</>,
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: <>And here is the date that you uploaded the report to disputely</>,
      disableBeacon: true,
    },
    {
      target: '.fifth-step',
      content: <>Here is the provider of the credit report</>,
      disableBeacon: true,
    },
    {
      target: '.sixth-step',
      content: <>Finally, here are your credit scores as of the date of the "Credit Report Date".</>,
      disableBeacon: true,
    },
    {
      target: '.seventh-step',
      content: <>P.S. You can come back here any time and download any of your past reports, anytime you want. 24/7! Even on holidays or if the opening manager slept through their alarm!</>,
      disableBeacon: true,
    },
  ];
  // Tour Progresses
  const tourStatus = useSelector(state => state.tourProgress.status);
  const tours = useSelector(state => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === 'idle') dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (tours.filter(tour => tour.tour_name === 'credit-report' && tour.completed).length === 0) setRun(true);
    else if (['loading', 'idle'].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);

  const handleJoyrideCallback = data => {
    const { type, status, index, action } = data;
    if (type === 'tour:end') dispatch(updateTourProgress({ tour_name: 'credit-report', completed: 1 }));
  };

  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const creditReportStatus = useSelector(state => state.creditReport.status);
  const creditReportData = useSelector(state => state.creditReport.creditReport);
  const error = useSelector(state => state.creditReport.error);
  useEffect(() => {
    if (creditReportStatus === 'idle') {
      dispatch(fetchCreditReport());
    }
  }, [creditReportStatus, dispatch]);

  moment.locale('en', {
    ordinal: num => {
      const b = num % 10;
      const output = ~~((num % 100) / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return num + '<sup>' + output + '</sup>';
    },
  });

  if (creditReportStatus === 'loading') {
    return <Loader />;
  } else if (creditReportStatus === 'failed') {
    notyf.open({
      type: 'danger',
      message: error,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }

  return (
    <React.Fragment>
      <Helmet title='Credit Report' />
      <style>
        {`
            tbody {
                border: none;
            }
            th {
                font-size: 14px;
                font-weight: normal;
                color: var(--bs-light-gray);
                font-family: 'Anek Bangla', sans-serif !important;
                text-align: center;
            }
            td {
                text-align: center;
                padding-top: 1rem !important;
                padding-bottom: 1rem !important;
            }

            tr:last-child td {
                border: none;
            }

            .content {

                align-items:start;
            }

            /* Change the button background color */
            .react-joyride__tooltip button {
              background-color: #0076FF !important; /* Change this to your desired color */
              border-color: #0076FF !important; /* Change this to your desired color */
            }

            /* Change the button hover background color */
            .react-joyride__tooltip button:hover {
              background-color: #1b1848 !important; /* Change this to your desired hover color */
              border-color: #0076FF !important; /* Change this to your desired hover color */
            }

            /* Change the button properties */
            .react-joyride__tooltip button[type="button"][data-action="back"] {
              appearance: none !important;
              background-color: transparent !important;
              border-style: none !important;
              color: #0076FF !important;
              cursor: pointer !important;
              font-family: "Anek Bangla", sans-serif !important;
              font-size: 16px !important;
              font-weight: 400 !important;
              line-height: 16px !important;
              margin: 0 !important;
              margin-right: auto !important;
              padding: 8px !important;
              text-align: center !important;
              text-transform: none !important;
              visibility: visible !important;
            }

            /* Change the button hover properties */
            button[type="button"][data-action="back"]:hover {
              color: var(--bs-dark-blue) !important; 
              background-color: none !important; 
              
            }

            div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
              flex: inherit !important;
            }

          `}
      </style>
      <Container fluid className='p-0 container-fluid-1335'>
        <Joyride showSkipButton={true} locale={{ last: 'FINISH' }} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={false} hideCloseButton disableOverlayClose={true} disableCloseOnEsc={true} callback={handleJoyrideCallback} />
        <Row className='mb-4'>
          <Col className='d-flex flex-row justify-content-between'>
            <h4 className='my-auto'>Access Previous Credit Reports</h4>
            <Button variant='primary' className='d-none fs-16'>
              Request Updated Report
            </Button>
          </Col>
        </Row>

        <Row className='mb-4'>
          {creditReportData &&
            Object.keys(creditReportData).length > 0 &&
            creditReportData.error == 0 &&
            creditReportData.data.map((value, index) => (
              <Col className='mb-4' lg={4} md={6}>
                <Card key={index} className='shadow border-0 p-4 mb-0 first-step rounded-4'>
                  <Card.Header className='border-0 bg-white d-flex align-items-center justify-content-between mb-3' style={{ height: '40px' }}>
                    <h4 className='mb-0 lh-1 second-step'>Credit Report {value.date && moment(value.date).format('MM/DD/Y')}</h4>
                    <a href={value.file_name} className='text-decoration-none text-primary seventh-step' download={`${value.provider}_CreditReport_${moment(value.date).format('MM_D_Y')}.pdf`} target='_blank' rel='noreferrer'>
                      <Download className='text-primary ms-2' width={20} height={20} strokeWidth={2} />
                    </a>
                  </Card.Header>
                  <Card.Body className='py-1'>
                    <Col className='d-flex flex-row justify-content-between align-items-center mb-3  fifth-step'>
                      <div>Provider:</div>
                      <div>{value.provider}</div>
                    </Col>
                    <Col className='d-flex third-step flex-row justify-content-between align-items-center mb-3'>
                      <div>Credit Report Date:</div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: value.report_date && moment(value.report_date).format('MMMM Do Y'),
                        }}></div>
                    </Col>
                    <Col className='d-flex fourth-step flex-row justify-content-between align-items-center my-3'>
                      <div>Date Report Added:</div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: value.report_added_date && moment(value.report_added_date).format('MMMM Do Y'),
                        }}></div>
                    </Col>
                    <Row className='d-flex flex-row justify-content-between sixth-step align-items-center mb-3'>
                      <Col xs={5}>
                        <div>Score:</div>
                      </Col>
                      <Col xs={7} className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='d-flex flex-row align-items-center'>
                          <Image src={TransUnionLogoSm} className='text-primary me-2' width={20} height={20} />
                          <div>{value.tr_score  < 350 ? 'N/A' : value.tr_score}</div>
                        </div>
                        <div className='d-flex flex-row align-items-center ms-3'>
                          <Image src={EquifaxLogoSm} className='text-primary me-2' width={20} height={20} />
                          <div>{value.eq_score  < 350 ? 'N/A' : value.eq_score}</div>
                        </div>
                        <div className='d-flex flex-row align-items-center ms-3'>
                          <Image src={ExperianLogoSm} className='text-primary me-2' width={20} height={20} />
                          <div>{value.ex_score  < 350 ? 'N/A' : value.ex_score}</div>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default CreditReport;
